function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "AppClearbit_svg__18_a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1BA6FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#148EFC"
})), React.createElement("linearGradient", {
  id: "AppClearbit_svg__19_b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#56BAFD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#53B7FD"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#AppClearbit_svg__18_a)",
  d: "M8.012 0H15v30H8.012c-2.786 0-3.796-.29-4.815-.835a5.679 5.679 0 01-2.362-2.362C.29 25.784 0 24.773 0 21.988V8.012c0-2.786.29-3.796.835-4.815A5.679 5.679 0 013.197.835C4.216.29 5.227 0 8.012 0z"
}), React.createElement("path", {
  fill: "url(#AppClearbit_svg__19_b)",
  d: "M15 0h6.988c2.786 0 3.796.29 4.815.835a5.679 5.679 0 012.362 2.362c.545 1.019.835 2.03.835 4.815V15H15V0z"
}), React.createElement("path", {
  fill: "#F2FAFE",
  d: "M30 15v6.988c0 2.786-.29 3.796-.835 4.815a5.679 5.679 0 01-2.362 2.362c-1.019.545-2.03.835-4.815.835H15V15h15z"
}));

var SvgAppClearbit = function SvgAppClearbit(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2);
};

export default SvgAppClearbit;